export default {
  hero_title: 'Willkommen zurück!',
  hero_subtitle: 'Halte dein Gesicht zur Sonne und die Schatten werden hinter dir bleiben.',
  title: 'Anmeldung zum persönlichen Konto von Estimator24',
  subtitle: 'Geben Sie Ihre Daten ein, um fortzufahren.',
  email: 'E-Mail',
  password: 'Passwort',
  remember_me: 'Angemeldet bleiben',
  submit: 'Einloggen',
  register_link: 'Konto erstellen'
}
